import { createContext } from 'react';

import { IInventoryContext } from '@lamesarv-sdk/inventory';

export const InventoryContext = createContext<IInventoryContext>({} as IInventoryContext);
